export default __webpack_public_path__ + "static/media/earth_small_2.2ae189bd.svg";